export const populationTallyByLocationActions = {
  populatePopulationTalliesByLocation:
    "POPULATE_POPULATION_TALLIES_BY_LOCATION",
  populationTallyByLocationLoading: "POPULATION_DATA_TALLY_BY_LOCATION_LOADING",
  populationTallyByLocationLoadError:
    "POPULATION_DATA_TALLY_BY_LOCATION_LOAD_ERROR"
};
